import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../components/AnimatedSection';
import './BeliefsSection.scss';
import churchCommunity from '../../assets/images/church/beliefs-hero.webp';

const BeliefsSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const slideLeft = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, x: -40 },
              whileInView: { opacity: 1, x: 0 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.2, ease: EASE_OUT_EXPO },
          };

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const fadeIn = (delay) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0 },
                  whileInView: { opacity: 1 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration: 1.0, delay, ease: EASE_OUT_EXPO },
              };

    return (
        <section className="beliefs-section">
            <div className="beliefs-section__container">
                <div className="beliefs-section__grid">
                    <motion.div className="beliefs-section__image" {...slideLeft}>
                        <img
                            src={churchCommunity}
                            alt={t('alt_church_community')}
                            className="beliefs-section__img"
                            loading="lazy"
                        />
                    </motion.div>

                    <div className="beliefs-section__content">
                        <motion.span className="beliefs-section__label" {...fadeIn(0.2)}>
                            {t('beliefs_unite')}
                        </motion.span>
                        <motion.h2 className="beliefs-section__title" {...fadeUp(0.35, 1.1)}>
                            {t('beliefs_title')}
                        </motion.h2>
                        <motion.p className="beliefs-section__description" {...fadeUp(0.5)}>
                            {t('beliefs_description')}
                        </motion.p>
                        <motion.div {...fadeUp(0.65, 0.9)}>
                            <Link to="/about" className="button button--primary">
                                {t('more_about_us')}
                            </Link>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BeliefsSection;
